<template>
  <div class="wrapper">
    <div class="header">
      <Button type="primary" @click="add">发布新岗位</Button>
      <Button type="text" @click="importModal = true" style="margin-left: 20px">批量上传</Button>
      <div class="select">
        <Input
          suffix="ios-search"
          v-model="keyword"
          placeholder="搜索"
          style="width: 200px; margin-right: 20px"
          search
          @on-search="getList()"
        />
        <Select v-model="status" style="width: 100px" @on-change="getList()">
          <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
    </div>
    <div class="content">
      <Row :gutter="20" type="flex">
        <Col :span="12" v-for="(item, index) in list" :key="index">
          <div class="item">
            <div class="status" :class="'status' + item.status">{{ item.statusString }}</div>
            <div class="box">
              <div class="name">
                <span class="title">{{ item.title }}</span>
                <span class="salary">{{ item.salaryString }}</span>
              </div>
              <div class="company">
                <i class="iconfont icon-qiye2"></i>
                {{ item.companyName }}
              </div>
              <div class="address">
                <i class="iconfont icon-dizhi"></i>
                {{ item.address }}
              </div>
              <Row type="flex" :gutter="10" class="mark">
                <Tag color="blue" v-if="item.workYearString">{{ item.workYearString }}</Tag>
                <Tag color="red" v-if="item.degreeString">{{ item.degreeString }}</Tag>
                <Tag color="green" v-for="benefit in item.benefit" :key="benefit">{{ benefit }}</Tag>
              </Row>
            </div>
            <div class="btn">
              <div
                @click.stop="item.status !== 1 && item.status !== 3 && goResumeList(item.id)"
                class="redact"
                :style="{ color: item.status !== 1 && item.status !== 3 ? '' : '#aaaaaa' }"
              >
                查看投递
              </div>
              <div @click.stop="edit(item.id)" class="edit">编辑</div>
              <div @click.stop="setStatus(item, 1)" v-if="item.status !== 2 && item.status !== 1 && item.isUnionOpera !== 1" class="up">
                提交审核
              </div>
              <div @click.stop="setStatus(item, 4)" v-if="item.status === 2" class="down">下架</div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <Page :total="pagination.count" @on-change="changePage" />
    <no-data v-if="list.length == 0">暂无数据</no-data>
    <Modal v-model="importModal" title="批量上传" :width="900" :footer-hide="true">
      <div>
        <Row type="flex" align="middle" style="margin-bottom: 20px">
          <Upload :action="$uploader.action" :show-upload-list="false" :before-upload="beforeUpload" :format="['xlsx']">
            <Button icon="ios-cloud-upload-outline">上传文件</Button>
          </Upload>
          <a type="text" target="_blank" :href="templateUrl" style="margin-left: 20px">模版下载</a>
        </Row>

        <Table :columns="errorsColumn" :data="errors" v-if="errors && errors.length"></Table>
        <Table :columns="importColumn" :data="toImportData" v-else height="400">
          <template v-slot:salaryPer="{ row }">
            {{ getSalaryPer(row.salaryPer) }}
          </template>
          <template v-slot:degree="{ row }">
            {{ getDegree(row.degree) }}
          </template>
        </Table>
        <div style="margin-top: 10px;text-align: center;">
          <Checkbox v-model="jobChecked">
            我已阅读并同意
            <a style="color: red" @click="goAgreement">《岗位协议》</a>
            ，承诺上传的岗位信息真实、合法、准确，遵守平台规定，如有违反，愿承担相应责任。
          </Checkbox>
        </div>
        <div slot="footer" style="margin-top: 20px; text-align: right">
          <Button :loading="loading" type="primary" v-if="!errors.length && toImportData.length" @click="handleImport">确认导入</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { read } from '@/libs/excel';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      loading: false,
      importModal: false,
      templateUrl:
        process.env.NODE_ENV === 'development' ? '/岗位批量导入模板V2-企业.xlsx' : '/enterprise_web/岗位批量导入模板V2-企业.xlsx',
      statusList: [
        {
          value: '',
          label: '全部状态'
        },
        {
          value: 0,
          label: '草稿'
        },
        {
          value: 1,
          label: '待审核'
        },
        {
          value: 2,
          label: '已发布'
        },
        {
          value: 3,
          label: '审核不通过'
        },
        {
          value: 4,
          label: '已下架'
        }
      ],
      status: '',
      list: [],
      keyword: '',
      pagination: {},
      importMap: {
        一级岗位类型: { type: 'string', requied: true, key: 'position1' },
        二级岗位类型: { type: 'string', requied: true, key: 'position2' },
        三级岗位类型: { type: 'string', requied: true, key: 'position' },
        三方系统岗位编号: { type: 'string', requied: false, key: 'thirdPartyId' },
        岗位名称: { type: 'string', requied: true, key: 'title' },
        // 岗位类型: {type: 'string', requied: true, key: 'position'},
        岗位描述: { type: 'string', requied: true, key: 'jd' },
        招聘人数: { type: 'int', requied: true, key: 'headCount' },
        联系人电话信息: { type: 'string', requied: true, key: 'contactPhone' },
        联系人姓名: { type: 'string', requied: true, key: 'contactName' },
        联系人邮箱: { type: 'string', requied: false, key: 'contactEmail' },
        省份: { type: 'string', requied: true, key: 'provinceName' },
        城市: { type: 'string', requied: true, key: 'cityName' },
        区县: { type: 'string', requied: false, key: 'districtName' },
        街道: { type: 'string', requied: false, key: 'streetName' },
        结算方式: {
          type: 'string',
          requied: true,
          key: 'salaryPer',
          array: ['面议', '小时结', '日结', '周结', '月结', '项目结', '按件结']
        },
        薪资下限: { type: 'int', requied: true, key: 'salaryMin' },
        薪资上限: { type: 'int', requied: true, key: 'salaryMax' },
        最低学历: {
          type: 'string',
          requied: false,
          key: 'degree',
          array: ['不限', '初中及以下', '中专/中技', '高中', '大专', '本科', '硕士', '博士']
        },
        年龄下限: { type: 'int', requied: false, key: 'ageMin' },
        年龄上限: { type: 'int', requied: false, key: 'ageMax' },
        福利待遇: { type: 'array', requied: false, key: 'benefit' },
        工作地点: { type: 'string', requied: true, key: 'address' },
        经度: { type: 'float', requied: false, key: 'longitude' },
        纬度: { type: 'float', requied: false, key: 'latitude' }
      },
      requiredCheckMeta: {},
      errors: [],
      toImportData: [],
      errorsColumn: [
        {
          title: '错误行',
          width: 100,
          key: 'row'
        },
        {
          title: '错误信息',
          key: 'content'
        }
      ],
      importColumn: [
        { key: 'thirdPartyId', width: 100, title: '三方系统岗位编号' },
        { key: 'title', width: 200, title: '岗位名称' },
        { key: 'position', width: 200, title: '三级岗位类型' },
        { key: 'jd', width: 200, title: '岗位描述' },
        { key: 'headCount', width: 100, title: '招聘人数' },
        { key: 'contactPhone', width: 100, title: '联系人电话信息' },
        { key: 'contactName', width: 100, title: '联系人姓名' },
        { key: 'contactEmail', width: 100, title: '联系人邮箱' },
        { key: 'provinceName', width: 100, title: '省份' },
        { key: 'cityName', width: 100, title: '城市' },
        { key: 'districtName', width: 100, title: '区县' },
        { key: 'streetName', width: 100, title: '街道' },
        { key: 'salaryPer', width: 100, slot: 'salaryPer', title: '结算方式' },
        { key: 'salaryMin', width: 100, title: '薪资下限' },
        { key: 'salaryMax', width: 100, title: '薪资上限' },
        { key: 'degree', width: 120, slot: 'degree', title: '最低学历' },
        { key: 'ageMin', width: 100, title: '年龄下限' },
        { key: 'ageMax', width: 100, title: '年龄上限' },
        { key: 'benefit', width: 200, title: '福利待遇' },
        { key: 'address', width: 200, title: '工作地点' },
        { key: 'longitude', width: 200, title: '经度' },
        { key: 'latitude', width: 200, title: '纬度' }
      ],
      jobChecked: false
    };
  },
  mounted() {
    this.getList();
    this.initRequiredCheckMeta();
    this.getHelpCount();
  },
  methods: {
    ...mapActions(['getHelpCount']),
    handleImport() {
      if (this.loading) {
        return;
      }
      if (!this.jobChecked) {
        this.$Message.error({
          content: '请阅读并同意《岗位协议》'
        });
        return;
      }
      this.$Modal.confirm({
        title: '导入',
        content: '确定导入？',
        onOk: () => {
          this._doImport();
        }
      });
    },
    _doImport() {
      this.loading = true;
      this.$axios
        .request({
          url: 'front/v1/job/import',
          method: 'post',
          data: this.toImportData
        })
        .then(res => {
          this.loading = false;
          this.$Message.success('导入成功，数据处理可能会有延迟，请稍后刷新查看');
          this.importModal = false;
          this.getList();
        })
        .catch(res => {
          this.loading = false;
        });
    },
    getSalaryPer(idx) {
      return ['面议', '小时结', '日结', '周结', '月结', '项目结', '按件结'][idx];
    },
    getDegree(idx) {
      return ['不限', '初中及以下', '中专/中技', '高中', '大专', '本科', '硕士', '博士'][idx];
    },
    initRequiredCheckMeta() {
      Object.keys(this.importMap).forEach(key => {
        if (this.importMap[key].requied) {
          this.requiredCheckMeta[this.importMap[key].key] = key;
        }
      });
    },

    beforeUpload(file) {
      this.errors = [];
      this.toImportData = [];
      const reader = new FileReader();
      reader.onload = e => {
        const data = e.target.result;
        let obj = read(data, 'binary');
        const toImportData = [];
        obj.results.forEach((row, index) => {
          let rowJson = this.processRow(row, index);
          toImportData.push(rowJson);
        });
        this.checkMinSalary(toImportData);
      };
      reader.readAsBinaryString(file);
      return false;
    },
    processRow(row, index) {
      let res = {};
      Object.keys(row).forEach(key => {
        let meta = this.importMap[key];
        if (!meta) {
          return;
        }
        let data;
        if (meta.type === 'string') {
          data = '' + row[key];
        } else if (meta.type === 'int') {
          data = parseInt(row[key]);
        } else if (meta.type === 'float') {
          data = parseFloat(row[key]);
        } else if (meta.type === 'array') {
          if (!row[key]) {
            data = [];
          } else {
            data = (row[key] + '').split(',').map(item => item.trim());
          }
        }
        if (meta.array) {
          let idx = 0;
          meta.array.forEach((item, i) => {
            if (item === data) {
              idx = i;
            }
          });
          data = idx;
        }
        res[meta.key] = data;
      });
      Object.keys(this.requiredCheckMeta).forEach(key => {
        // if (!res[key]) {
        if (!(key === 'salaryPer' ? typeof res[key] === 'number' : res[key])) {
          this.errors.push({ row: index + 1, content: '请输入必填项-' + this.requiredCheckMeta[key] });
        }
      });
      if (res.salaryPer !== 0 && !res.salaryMin && !res.salaryMax) {
        this.errors.push({ row: index + 1, content: '请输入薪资范围' });
      }
      return res;
    },
    async checkMinSalary(rowList) {
      const minSalaryMap = await this.getMinSalary(rowList);
      rowList.forEach((v, i) => {
        // if (!v.districtId) {
        //   return;
        // }
        const propertyNameMap = {
          1: 'hourly',
          4: 'monthly'
        };
        const minSalaryForDistrictBucket = minSalaryMap.get(this.getRowMinSalaryKey(v));
        if (!minSalaryForDistrictBucket) {
          return;
        }
        const minSalaryForDistrict = minSalaryForDistrictBucket[propertyNameMap[v.salaryPer]];
        if (!minSalaryForDistrict) {
          return;
        }
        if (minSalaryForDistrict > (v.salaryMin || 0)) {
          const salaryPerStr = this.getSalaryPer(v.salaryPer);
          this.errors.push({ row: i + 1, content: `该地区最低${salaryPerStr}薪资为${minSalaryForDistrict}` });
        }
      });
      if (!this.errors || !this.errors.length) {
        this.toImportData = rowList;
      }
    },
    async getMinSalary(rowList) {
      const codes = rowList && rowList.filter(v => v.districtId && (v.salaryPer === 1 || v.salaryPer === 4)).map(v => this.getRowMinSalaryKey(v));
      const names = rowList && rowList.filter(v => !v.districtId && v.provinceName && v.cityName && (v.salaryPer === 1 || v.salaryPer === 4)).map(v => this.getRowMinSalaryKey(v));
      const codeRes = await this.getSalaryMinByDistrictCode({ codes: [...new Set(codes)] });
      const nameRes = await this.getSalaryMinByName({ names: [...new Set(names)] });
      const minSalaryMap = new Map();
      codeRes && codeRes.forEach(v => {
        minSalaryMap.set(v.code, {
          monthly: v.monthly,
          hourly: v.hourly
        });
      });
      nameRes && nameRes.forEach(v => {
        minSalaryMap.set(v.name, {
          monthly: v.monthly,
          hourly: v.hourly
        });
      });
      return minSalaryMap;
    },
    getRowMinSalaryKey(row) {
      if (row.districtId) {
        return row.districtId;
      } else if (row.provinceName && row.cityName) {
        return `${row.provinceName}-${row.cityName}` + (row.districtName ? `-${row.districtName}` : '');
      }
    },
    getSalaryMinByDistrictCode(data) {
      return new Promise(resolve => {
        this.$axios
          .request({
            url: 'front/v1/salary-min/job',
            data: data,
            method: 'post'
          })
          .then(res => {
            resolve(res.data);
          });
      });
    },
    getSalaryMinByName(data) {
      return new Promise(resolve => {
        this.$axios
          .request({
            url: 'front/v1/salary-min/job/name',
            data: data,
            method: 'post'
          })
          .then(res => {
            resolve(res.data);
          });
      });
    },
    getList(page = 1) {
      this.pagination.pageIndex = page;
      this.$axios
        .request({
          url: 'front/v1/job',
          params: {
            pageIndex: this.pagination.pageIndex,
            title: this.keyword,
            status: this.status,
            idOrder: 'desc'
          },
          method: 'get'
        })
        .then(res => {
          this.list = res.data.list;
          this.pagination = { count: res.data.count, pageIndex: res.data.pageIndex, pageSize: res.data.pageSize };
        });
    },
    changePage(page) {
      this.getList(page);
    },
    add() {
      this.$router.push({ name: 'zhiweiEdit' });
    },
    edit(id) {
      this.$router.push({ name: 'zhiweiEdit', query: { id: id } });
    },
    goResumeList(id) {
      this.$router.push({ name: 'jianliIndex', query: { jobId: id, from: true } });
    },
    setStatus(item, status) {
      let data = Object.assign({}, item, { status: status });
      this.$Modal.confirm({
        content: status == 1 ? '确认提交审核该岗位' : '确认下架该岗位',
        onOk: () => {
          this.$axios
            .request({
              url: 'front/v1/job/' + item.id,
              method: 'put',
              data: data
            })
            .then(res => {
              this.getList(this.pagination.pageIndex);
            });
        }
      });
    },
    goAgreement() {
      const routeData = this.$router.resolve({
        name: 'CompanyAgreement' // 或使用 name: 'route-name'
      });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  .header {
    display: flex;
    .select {
      flex: 1;
      text-align: right;
    }
  }
  .content {
    margin-top: 12px;
    margin-bottom: 20px;
    .item {
      background: #fff;
      border-bottom: 1px solid #eee;
      align-items: center;
      padding: 20px 30px;
      position: relative;
      transition: all linear 0.3s;
      margin-bottom: 20px;
      &:hover {
        box-shadow: 0 0 10px #aaa;
      }
      .status {
        position: absolute;
        top: 0;
        right: 0;
        padding: 5px 10px;
        color: #fff;
        background: #00a854;
        &.status0 {
          color: #495060;
          background: #eee;
        }
        &.status1 {
          color: #fff;
          background: #ffa500;
        }
        &.status3 {
          color: #fff;
          background: rgb(255, 0, 0);
        }
        &.status4 {
          color: #495060;
          background: #eee;
        }
      }

      > .box {
        flex: 1;
        .name {
          color: #363e4f;
          font-size: 18px;
          margin-bottom: 16px;
          .salary {
            color: #d6000f;
            font-size: 14px;
            margin-left: 15px;
          }
        }
        > .mark {
          display: flex;
          color: #363e4f;
          font-size: 14px;
          align-items: center;
          opacity: 0.7;
          > div {
            display: flex;
            align-items: center;
          }
          // > div::after {
          //   content: '';
          //   display: inline-block;
          //   height: 14px;
          //   margin: 0 10px;
          //   width: 1px;
          //   background: #363e4f;
          // }
          // > div:last-child::after {
          //   content: '';
          //   width: 0;
          // }
        }
      }
      > .btn {
        display: flex;
        justify-content: flex-end;
        box-sizing: border-box;
        cursor: pointer;
        > div {
          padding: 5px 10px;
          color: rgb(64, 158, 255);
          position: relative;
          &.edit {
            color: #999;
          }
          &.down {
            color: rgb(245, 108, 108);
          }
          &.up {
            color: rgb(103, 194, 58);
          }
          &::after {
            content: '';
            height: 10px;
            width: 1px;
            position: absolute;
            top: 10px;
            right: 0;
            background: #aaa;
          }
          &:last-child::after {
            content: '';
            width: 0;
          }
        }
      }
    }
  }
}
</style>
